
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IRuta } from '../models/ruta';
import { RutaService } from '../services/ruta.service';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClienteService } from '../services/cliente.service';
import { CiudadService } from '../services/ciudad.service';
import { ProyectoService } from '../services/proyecto.service';
import { TipotransporteService } from '../services/tipotransporte.service';
import { IProyecto } from '../models/proyecto';
import { ICiudad } from '../models/ciudad';
import { ICliente } from '../models/cliente';
import { ITipoTransporte } from '../models/tipotransporte';
import { IResultadoGeneral } from '../models/resultadogeneral';
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import { AuthService } from '../services/auth.service';
import ICredencialUsuario from '../models/credencial';
import { IEstatus } from '../models/estatus';
import { ISituacion } from '../models/situacion';
import { ConfunidadService } from '../services/confunidad.service';
import { IConfiguracionUnidad } from '../models/confUnidad';
import { IRutaEspecial } from '../models/ruta_especial';
import { IDataGuardarFolio } from '../models/data_folio';
import { IMes } from '../models/mes';
import { Isoporte } from '../models/catsoporte';

@Component({
  selector: 'app-catalogocobranza',
  templateUrl: './catalogocobranza.component.html',
  styleUrls: ['./catalogocobranza.component.scss']
})
export class CatalogocobranzaComponent implements OnInit {
  @ViewChild('dt1') dt!: Table;
  lstRutas: IRuta[] = [];
  loading: boolean = false;
  dspEditarRuta: boolean = false;

  foliosForm: FormGroup = new FormGroup({
    id_soporte : new FormControl(0),
    nombre: new FormControl('', [Validators.required]),
    descripcion: new FormControl('', [Validators.required]),
    cod_usuario_modifico: new FormControl(''),

  });

  lstProyectos: IProyecto[] = [];
  lstCiudades: ICiudad[] = [];
  lstClientes: ICliente[] = [];
  lstTransporte: ITipoTransporte[] = [];
  lstConfUnidad: IConfiguracionUnidad[] = [];

  lstTarifa = [{
      clv_tarifa: 1,
      desc_tarifa: 'SPOT'
    },
    {
      clv_tarifa: 2,
      desc_tarifa: 'DEDICADA'
    },
    {
      clv_tarifa: 3,
      desc_tarifa: 'EXTRAORDINARIA'
    }
  ];
  meses: IMes[] = [
    { num_mes: 1, nombre: "Enero" },
    { num_mes: 2, nombre: "Febrero" },
    { num_mes: 3, nombre: "Marzo" },
    { num_mes: 4, nombre: "Abril" },
    { num_mes: 5, nombre: "Mayo" },
    { num_mes: 6, nombre: "Junio" },
    { num_mes: 7, nombre: "Julio" },
    { num_mes: 8, nombre: "Agosto" },
    { num_mes: 9, nombre: "Septiembre" },
    { num_mes: 10, nombre: "Octubre" },
    { num_mes: 11, nombre: "Noviembre" },
    { num_mes: 12, nombre: "Diciembre" }];
  selectedMes: IMes = {
    num_mes: -1,
    nombre: ""
  }

  resultado: IResultadoGeneral = {
    clv_estatus: 0,
    messageDetails: ''
  }
  anio: any;
  selectedMesReporte1: IMes = {
    num_mes: -1,
    nombre: ""
  }
  anioReporte1: any;
  folioDescRuta: number = 0;

  dspDesativarRuta: boolean = false;
  dsbAgregarFolio : boolean = false;
  desc_ruta: string = '';
  color_rojo_especial: string = '#FF0000';
  color_gris_deshabilitadas: string = '#D9D9D9';
  desc_estatus :string ='';

  num_operacion: number = 0;
  //Registro
  user: ICredencialUsuario = {};

  constructor(private rutaService: RutaService,

    private confirmationService: ConfirmationService, private messageService: MessageService,
    private auth: AuthService,
    private confUnidadService: ConfunidadService) {
    this.cargarInformacionUsuario();

  }
  ngOnInit(): void {
    this.getListaDeRutas();

  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  getListaDeRutas() {
    this.loading = true;
    this.rutaService.getlistadoSoportesCobranza().subscribe((resp) => {
      this.lstsoporte = resp;
      setTimeout(() => {
        this.loading = false;
      },
        800);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de RUTAS');
        this.loading = false;
      });
  }



  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }





//metodo para validaar si existe

//-------------hacer un get que reciba la info  o implemntarlo al  que esta ctualmente



  confirmarDesactivar(clave_ruta: number, ruta: IRuta) {

    let estatus_original = ruta.clv_disponible;
    let texto_desactivar: string = ruta.clv_disponible == 1 ? 'DESACTIVAR' : 'ACTIVAR';
    let texto_desactivar_header: string = ruta.clv_disponible == 1 ? 'Desactivar' : 'Activar';
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>' + texto_desactivar + '</b> la Ruta <b>' + ruta.desc_ruta + '</b> ?',
      header: 'Confirmacion de ' + texto_desactivar_header,
      icon: 'pi pi-info-circle',
      accept: () => {
       // ruta.clv_disponible = ruta.clv_disponible == 1 ? 0 : 1;
      //  this.guardarInformacionDesactivarRuta(ruta);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            ruta.clv_disponible = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Cancelado' });
            break;
          case ConfirmEventType.CANCEL:
            ruta.clv_disponible = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Cancelado' });
            break;
        }
      }
    });

  }

 lstsoporte :Isoporte []=[];


  Editar(data : Isoporte) {

    this.foliosForm.controls['id_soporte'].setValue(data.id_soporte),
    this.foliosForm.controls['nombre'].setValue(data.nombre),
    this.foliosForm.controls['descripcion'].setValue(data.descripcion),
    this.foliosForm.controls['cod_usuario_modifico'].setValue(data.cod_usuario_modifico),
    setTimeout(() => {
      this.dspeditar =true;
    }, 300);
  }





  lstRutasCompleto:any



  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }




  guardar() {
    let data_enviar  ={
      nombre: this.foliosForm.get('nombre')?.value,
      descripcion: this.foliosForm.get('descripcion')?.value,
      usuario_registro: this.user.cod!,
    };
    this.rutaService.guardarcat(data_enviar).subscribe((resp)=> {
     this.resultado = resp

      if(this.resultado.clv_estatus==-2){
        this.mostrarDialogoInformativo(this.resultado.messageDetails);
      } else {
        setTimeout(() => {
          this.getListaDeRutas();
           this.cancelaragregar()
          this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se actualizo de forma correcta' });
        },
          800);
      }
    },
    (error)=> {
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Guardar Catalogo>', detail: 'Contacte al Administrador del Sitio' });
    },
  );
  }


  guardareditar() {
    this.loading=true;
    let data_enviar  ={
      id_soporte : this.foliosForm.get('id_soporte')?.value,
      nombre: this.foliosForm.get('nombre')?.value,
      descripcion: this.foliosForm.get('descripcion')?.value,
      cod_usuario_modifico: this.user.cod!,
    };
    this.rutaService.editarsoporte(data_enviar).subscribe((resp)=> {
     this.resultado = resp

      if(this.resultado.clv_estatus==-2){
        this.mostrarDialogoInformativo(this.resultado.messageDetails);
      } else {
        setTimeout(() => {
          this.getListaDeRutas();
        this.cancelareditar()
          this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se actualizo de forma correcta' });
        },
          800);
      }
    },
    (error)=> {
      this.loading=false;
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Editar Catalogo>', detail: 'Contacte al Administrador del Sitio' });
    },
  );
  }








  cambiarestatus(data: Isoporte) {

 if(data.estatus == 1){
  this.desc_estatus= 'DESACTIVAR'
 }else{
   this.desc_estatus= 'ACTIVAR'
 }

    this.confirmationService.confirm({
    message: '¿Esta seguro que desea <b>'+ this.desc_estatus+ '</b> el catologo de soporte cobranza <b>' + data.nombre +'</b>?',
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {



    this.loading=true;
    this.foliosForm.controls['id_soporte'].setValue(data.id_soporte)
    let data_enviar  ={
      id_soporte : this.foliosForm.get('id_soporte')?.value,
      cod_usuario_modifico: this.user.cod!,
    };
    this.rutaService.cambiarestatussoportecobranza(data_enviar).subscribe((resp)=> {
     this.resultado = resp

      if(this.resultado.clv_estatus==-2){
        this.mostrarDialogoInformativo(this.resultado.messageDetails);
      } else {
        setTimeout(() => {
          this.getListaDeRutas();
          this.messageService.add({ key: 'msj', severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se actualizo de forma correcta' });
        },
          800);
      }
    },
    (error)=> {
      this.loading=false;
      this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error en <Cambiar Estatus>', detail: 'Contacte al Administrador del Sitio' });
    },
  );

}})
  }




  dspAgregar:boolean=false;
  loadinglst:boolean=false;
  dsbhistorico:boolean=false;

  mostrarhistorico(){
    this.dsbhistorico= true;
  }
  cancelarModalHistoricoFolios(){
    this.dsbhistorico= false
  }

  Agregar(){
    this.dspAgregar= true;
  }



  cancelaragregar(){
    this.dspAgregar= false
    this.foliosForm.reset()
  }


  dspeditar:boolean =false;



  cancelareditar(){
    this.dspeditar= false
    this.foliosForm.reset()
    this.loading=false;
  }





  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }




}
